import { Injectable } from '@angular/core';
import { catchError, map, Observable } from 'rxjs';
import { ConfigService, JSONRPC } from '../../../_constants/config/config.service';
import { XAPI_METHODS, XAPI_METHODS_NAMES, XAPIS } from '../../../../models/Core.model';
import { RequestsService } from '../requests.service';

@Injectable({
    providedIn: 'root'
})
export class ApiProxyUsersService {
    constructor(
        private readonly requestsService: RequestsService,
        private readonly configService: ConfigService
    ) { }

    public setClients(userId: number, clients: number[]): Observable<any> {
        const body: any = {
            id: parseInt((Math.random() * 100).toString(), 10),
            jsonrpc: JSONRPC,
            method: XAPI_METHODS[XAPIS.proxyUsers][XAPI_METHODS_NAMES.setClients],
            params: {
                user_id: userId,
                clients
            }
        };

        return this.requestsService.post(this.configService.getServerUrlXapi(), XAPIS.proxyUsers, body).pipe(
            map((resp: any) => {
                if (resp?.status === 0) {
                    return resp.result;
                }
                throw resp;
            }),
            catchError((error: any) => {
                throw error;
            })
        );
    }

    public listClients(): Observable<Record<string, number[]>> {
        const body: any = {
            id: parseInt((Math.random() * 100).toString(), 10),
            jsonrpc: JSONRPC,
            method: XAPI_METHODS[XAPIS.proxyUsers][XAPI_METHODS_NAMES.listUsersClients]
        };

        return this.requestsService.post(this.configService.getServerUrlXapi(), XAPIS.proxyUsers, body).pipe(
            map((resp: any) => {
                if (resp?.status === 0) {
                    return (resp.result ?? {}) as Record<string, number[]>;
                }
                throw resp;
            }),
            catchError((error: any) => {
                throw error;
            })
        );
    }

    public getInfo(): Observable<any> {
        const body: any = {
            id: parseInt((Math.random() * 100).toString(), 10),
            jsonrpc: JSONRPC,
            method: XAPI_METHODS[XAPIS.proxyUsers][XAPI_METHODS_NAMES.getInfo]
        };

        return this.requestsService.post(this.configService.getServerUrlXapi(), XAPIS.proxyUsers, body).pipe(
            map((resp: any) => {
                if (resp?.status === 0) {
                    return resp.result ?? null;
                }
                throw resp;
            }),
            catchError((error: any) => {
                throw error;
            })
        );
    }
}
